import {
  ApiOutlined,
  OrderedListOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { Layout, Menu, message } from "antd";
import { DragDropContext } from "react-beautiful-dnd";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { memo, useEffect, useState } from "react";
import api from "../../../api/api";

const UserQuestions = () => {
  const statNav = [
    {
      icon: <QuestionCircleOutlined />,
      label: <Link to="/question/new">طراحی سوال</Link>,
      key: "/question/new",
    },
    // {
    //   icon: <BuildOutlined />,
    //   label: <Link to="/user-questions/conditions">شروط</Link>,
    //   key: "/user-questions/conditions",
    // },
    {
      icon: <ApiOutlined />,
      label: (
        <Link to="/user-questions/questions-to-flags/41744/اتصال به کارت پرسشنامه اولیه">
          اتصال به کارت پرسشنامه اولیه
        </Link>
      ),
      key: "/user-questions/questions-to-flags/41744",
    },
    {
      icon: <ApiOutlined />,
      label: (
        <Link to="/user-questions/questions-to-flags/57755/اتصال به کارت پرسشنامه جدید بوکمارکی">
          اتصال به کارت پرسشنامه جدید بوکمارکی
        </Link>
      ),
      key: "/user-questions/questions-to-flags/57755",
    },
    {
      icon: <ApiOutlined />,
      label: (
        <Link to="/user-questions/questions-to-flags/61966/اتصال به کارت پرسشنامه روانشناسی">
          اتصال به کارت پرسشنامه روانشناسی
        </Link>
      ),
      key: "/user-questions/questions-to-flags/61966",
    },
    {
      icon: <ApiOutlined />,
      label: (
        <Link to="/user-questions/questions-to-flags/67506/اتصال به کارت پرسشنامه لایف کوچ اتوماتیک">
          اتصال به کارت پرسشنامه لایف کوچ اتوماتیک
        </Link>
      ),
      key: "/user-questions/questions-to-flags/67506",
    },
  ];

  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(true);
  const [navItems, setNavItems] = useState(statNav);

  let selectedNav = "/question/new";
  navItems.forEach((el) => {
    if (!el) return;

    if (el.key === location.pathname) {
      selectedNav = el.key;
    }
  });

  const getFormList = () => {
    api
      .get("/forms/list?forManager=true")
      .then((res) => {
        const formsData = res.data.map((form) => ({
          icon: <OrderedListOutlined />,
          label: (
            <Link to={`/question/${form.key}`}>{`پرسشنامه ${form.title}`}</Link>
          ),
          key: `/question/${form.key}`,
        }));

        setNavItems(() => [...statNav, ...formsData]);
      })
      .catch(() => message.error("خطا در دریافت لیست پرسشنامه ها"));
  };

  useEffect(() => {
    getFormList();
    if (location.pathname === "/question") {
      navigate("/question/new");
    }
  }, [location.pathname, navigate]);

  return (
    <Layout
      style={{
        background: "white",
      }}
    >
      <Layout.Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
        style={{
          padding: "1rem 0",
          background: "white",
        }}
        width={"20rem"}
      >
        <Menu
          mode="inline"
          defaultSelectedKeys={[selectedNav]}
          style={{
            height: "100%",
          }}
          items={navItems}
        />
      </Layout.Sider>
      <Layout.Content
        style={{
          padding: "0 24px",
          height: "100%",
          borderRadius: "6px",
        }}
      >
        <DragDropContext>
          <Outlet />
        </DragDropContext>
      </Layout.Content>
    </Layout>
  );
};

export default memo(UserQuestions);
